// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3g0Gg","error":"Textarea_error__tXzTX","readonly":"Textarea_readonly__25DM3","disabled":"Textarea_disabled__bHMCV"};